import {Colors} from "../colors";
import {Container} from "./Container";
import {Text} from "./Text";

interface UserDetailProps {
  detailName: string;
  detail?: string;
}

const UserDetail = ({detailName, detail}: UserDetailProps) => {
  return (
    <Container row sx={{gap: "4px"}}>
      <Text size={14} sx={{whiteSpace: "nowrap", color: Colors.grey._700}}>{`${detailName}: `}</Text>
      <Text
        size={14}
        sx={{
          maxWidth: "195px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {detail}
      </Text>
    </Container>
  );
};

export default UserDetail;
